import React, { useEffect, useState } from 'react';
import { GetCmsPages } from '../api.services.js/others'

import { Container } from 'react-bootstrap';
import Head from 'next/head';


export const getServerSideProps=async ()=>{
  const {data}=await GetCmsPages({identifier:"innovation"});
  return {
    props:{data}
  }
}

function Innovation(props) {
  const [cmsPage,setcmsPage]=useState(props?.data?.cmsPage?.content);
  const breadCrumbSchema = () => {
    return {
      __html: `{
        "@context": "https://schema.org/", 
        "@type": "BreadcrumbList", 
        "itemListElement": [{
          "@type": "ListItem", 
          "position": 1, 
          "name": "Home",
          "item": "https://www.orientbell.com"
        },{
        "@type": "ListItem", 
        "position": 2, 
        "name": "Innovation",
        "item": "https://www.orientbell.com/innovation"
      }]
      }`
    }
  }
  return (
   
    <>
    <Head>
    <title>{props?.data?.cmsPage?.meta_title}</title>
<meta name="title" content={props?.data?.cmsPage?.meta_title}/>
<meta name="description" content={props?.data?.cmsPage?.meta_description}/>
<meta name="keywords" content={props?.data?.cmsPage?.meta_keywords}/>
<script type="application/ld+json" dangerouslySetInnerHTML={ breadCrumbSchema()}/>
    </Head>
    <Container>
   
    <div dangerouslySetInnerHTML={{__html:cmsPage}}></div>
    </Container>
    </>
  )
}

export default Innovation